import { Injectable, inject } from "@angular/core";
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot } from "@angular/router";
import { environment } from "environments/environment";
import { AuthService } from "./auth.service";

@Injectable({
	providedIn: "root"
})
export class AuthGuardService {
	router = inject(Router);
	auth = inject(AuthService);

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
		if (!this.auth.isUserLoggedIn()) {
			this.auth.logout();
			return false;
		}

		const path = route.routeConfig.path;

		if (this.auth.needConfirmSecurityCode() && path !== "security-login") {
			this.auth.logout();
			return false;
		}

		const entorno = environment.entorno;
		const entornosRoute = route?.data?.environment || [];

		if (path !== "error/not-authorized" && entorno === "ewaste" && !entornosRoute.includes(entorno)) {
			this.router.navigate(["error/not-authorized"]);
			return false;
		}

		return true;
	}
}
